import { useState } from 'react'
import { Modal } from 'antd'
import type { RentalOrder } from '@super-mega/server/contracts/order'
import { RentalEnterpriseEditor } from './rental-enterprise-editor.tsx'

export function RentalContractEnterpriseModal({
  order,
  onOpenChange
}: {
  order: RentalOrder
  onOpenChange: (open: boolean) => void
}) {
  const [saving, setSaving] = useState(false)
  return (
    <Modal
      open
      title="补充服务对象资料"
      width="64rem"
      footer={null}
      styles={{ body: { height: 'calc(80vh - 5rem)', display: 'flex', overflow: 'hidden' } }}
      centered
      mask={{ closable: false }}
      closable={!saving}
      keyboard={!saving}
      onCancel={() => onOpenChange(false)}
    >
      <RentalEnterpriseEditor order={order} onBusyChange={setSaving} onSaved={() => onOpenChange(false)} />
    </Modal>
  )
}
